export type JotformiframeProps = {
  title: string
  formId: string
  height?: string
  urlParams?: Record<string, string>
}

export const PhnxJotformiframe: React.FC<JotformiframeProps> = () => {
  return null
}
